module.exports = __webpack_public_path__ + "img/9788960172241.24b3de87.jpg";